import {Theme} from '@mui/material/styles';

export const getInputTokens = (theme: Theme): Record<string, any> => ({
    'outlined-small': {
        containerHeight: '2rem',
        containerPadding: '0.25rem',
        inputHeight: '1.5rem',
        inputPadding: '0.5rem',
        itemSpacing: '0.5rem',
        fontSize: theme.tokens.FuelFontSizeSm,
        borderWidth: '1px',
        border: `solid 1px ${theme.tokens.FuelColorBorderDark}`, // default
        boxShadow: undefined,
        backgroundColor: 'white',
        focused: {
            outline: `solid 1px ${theme.tokens.FuelColorFocused}`,
            outlineOffset: '0px',
            borderColor: theme.tokens.FuelColorFocused
        }
    },
    'outlined-medium': {
        containerHeight: '2.25rem',
        containerPadding: '0.375rem',
        inputHeight: '1.5rem',
        inputPadding: '0.5rem',
        itemSpacing: '0.5rem',
        fontSize: theme.tokens.FuelFontSizeBase,
        borderWidth: '1px',
        border: `solid 1px ${theme.tokens.FuelColorBorderDark}`, // default
        boxShadow: undefined,
        backgroundColor: 'white',
        focused: {
            outline: `solid 1px ${theme.tokens.FuelColorFocused}`,
            outlineOffset: '0px',
            borderColor: theme.tokens.FuelColorFocused
        }
    },
    'outlined-large': {
        containerHeight: '2.5rem',
        containerPadding: '0.5rem',
        inputHeight: '1.5rem',
        inputPadding: '0.5rem',
        itemSpacing: '0.5rem',
        fontSize: theme.tokens.FuelFontSizeBase,
        borderWidth: '1px',
        border: `solid 1px ${theme.tokens.FuelColorBorderDark}`, // default
        boxShadow: undefined,
        backgroundColor: 'white',
        focused: {
            outline: `solid 1px ${theme.tokens.FuelColorFocused}`,
            outlineOffset: '0px',
            borderColor: theme.tokens.FuelColorFocused
        }
    },
    'elevated-small': {
        containerHeight: '2rem',
        containerPadding: '0.25rem',
        inputHeight: '1.5rem',
        inputPadding: '0.5rem',
        itemSpacing: '0.5rem',
        fontSize: theme.tokens.FuelFontSizeSm,
        borderWidth: '0px',
        border: 'none',
        boxShadow: theme.tokens.FuelShadowMd,
        backgroundColor: 'white',
        focused: {
            outline: `solid 2px ${theme.tokens.FuelColorFocused}`,
            outlineOffset: '-1px',
            borderColor: undefined
        }
    },
    'elevated-medium': {
        containerHeight: '2.25rem',
        containerPadding: '0.375rem',
        inputHeight: '1.5rem',
        inputPadding: '0.5rem',
        itemSpacing: '0.5rem',
        fontSize: theme.tokens.FuelFontSizeBase,
        borderWidth: '0px',
        border: 'none',
        boxShadow: theme.tokens.FuelShadowMd,
        backgroundColor: 'white',
        focused: {
            outline: `solid 2px ${theme.tokens.FuelColorFocused}`,
            outlineOffset: '-1px',
            borderColor: undefined
        }
    },
    'elevated-large': {
        containerHeight: '2.5rem',
        containerPadding: '0.5rem',
        inputHeight: '1.5rem',
        inputPadding: '0.5rem',
        itemSpacing: '0.5rem',
        fontSize: theme.tokens.FuelFontSizeBase,
        borderWidth: '0px',
        border: 'none',
        boxShadow: theme.tokens.FuelShadowMd,
        backgroundColor: 'white',
        focused: {
            outline: `solid 2px ${theme.tokens.FuelColorFocused}`,
            outlineOffset: '-1px',
            borderColor: undefined
        }
    },
    'filled-small': {
        containerHeight: '2rem',
        containerPadding: '0.25rem',
        inputHeight: '1.5rem',
        inputPadding: '0.5rem',
        itemSpacing: '0.5rem',
        fontSize: theme.tokens.FuelFontSizeSm,
        borderWidth: '0px',
        border: 'none',
        boxShadow: undefined,
        backgroundColor: theme.tokens.FuelColorGray100,
        focused: {
            outline: `solid 2px ${theme.tokens.FuelColorFocused}`,
            outlineOffset: '-1px',
            borderColor: 'transparent'
        }
    },
    'filled-medium': {
        containerHeight: '2.25rem',
        containerPadding: '0.375rem',
        inputHeight: '1.5rem',
        inputPadding: '0.5rem',
        itemSpacing: '0.5rem',
        fontSize: theme.tokens.FuelFontSizeBase,
        borderWidth: '0px',
        border: 'none',
        boxShadow: undefined,
        backgroundColor: theme.tokens.FuelColorGray100,
        focused: {
            outline: `solid 2px ${theme.tokens.FuelColorFocused}`,
            outlineOffset: '-1px',
            borderColor: 'transparent'
        }
    },
    'filled-large': {
        containerHeight: '2.5rem',
        containerPadding: '0.5rem',
        inputHeight: '1.5rem',
        inputPadding: '0.5rem',
        itemSpacing: '0.5rem',
        fontSize: theme.tokens.FuelFontSizeBase,
        borderWidth: '0px',
        border: 'none',
        boxShadow: undefined,
        backgroundColor: theme.tokens.FuelColorGray100,
        focused: {
            outline: `solid 2px ${theme.tokens.FuelColorFocused}`,
            outlineOffset: '-1px',
            borderColor: 'transparent'
        }
    }
});
